require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// ../~/angular-sanitize/index.js
// module id = 25
// module chunks = 3